import { cloneElement } from 'react'
import { useMergeRefs } from '@floating-ui/react'

function FloatingTooltipTrigger({
  children,
  context,
  getReferenceProps,
  ref: propRef,
}) {
  const ref = useMergeRefs([
    context.refs.setReference,
    propRef,
    children.props.ref,
  ])

  return cloneElement(children, {
    ...children.props,
    ...getReferenceProps({ ...children.props }),
    ref,
  })
}

export default FloatingTooltipTrigger
